import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes, NotificationTemplateEnum } from '@finxone-platform/shared/sys-config-types';

export const beneficiaryPushTranslations = {
  [Locale.en_GB]: {
    ADD_BENEFICIARY_TITLE: 'New Beneficiary Added',
    ADD_BENEFICIARY_DESCRIPTION:
      'A new beneficiary has been added to your account. Name: {{beneficiaryName}}. Review and manage your beneficiaries now.',
    UPDATE_BENEFICIARY_TITLE: 'Beneficiary details updated',
    UPDATE_BENEFICIARY_DESCRIPTION:
      'Beneficiary details have been updated. Name: {{beneficiaryName}}. Check your updated beneficiary information.',
    REMOVE_BENEFICIARY_TITLE: 'Beneficiary Removed',
    REMOVE_BENEFICIARY_DESCRIPTION:
      'A beneficiary has been removed from your account. Name: {{beneficiaryName}}. Review your current beneficiaries.',
  },
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateBeneficiaryPushAlerts = (translations: any) => ({
  [NotificationTemplateEnum.ADD_BENEFICIARY]: {
    name: 'Add Beneficiary',
    type: AlertTypes.INFO,
    title: translations.ADD_BENEFICIARY_TITLE,
    description: translations.ADD_BENEFICIARY_DESCRIPTION,
  },
  [NotificationTemplateEnum.UPDATE_BENEFICIARY]: {
    name: 'Update Beneficiary',
    type: AlertTypes.INFO,
    title: translations.UPDATE_BENEFICIARY_TITLE,
    description: translations.UPDATE_BENEFICIARY_DESCRIPTION,
  },
  [NotificationTemplateEnum.REMOVE_BENEFICIARY]: {
    name: 'Remove Beneficiary',
    type: AlertTypes.INFO,
    title: translations.REMOVE_BENEFICIARY_TITLE,
    description: translations.REMOVE_BENEFICIARY_DESCRIPTION,
  },
});
